module.exports = {
      id: "list-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#list",
      toString: function () {
        return this.url;
      }
    }